<template>
  <el-steps :active="activeIndex" :style="style" align-center>
    <el-step
      v-for="(step, index) in options"
      :key="index"
      :title="stepStatus(index) === 'error' && step.error ? step.error : step.title"
      :description="['finish', 'success', 'error'].includes(stepStatus(index)) ? step.desc : ''"
      :status="stepStatus(index, step.reject)"
    ></el-step>
  </el-steps>
</template>

<script>
export default {
  model: {
    prop: 'activeIndex',
    event: 'update'
  },
  props: {
    options: {
      type: Array,
      required: true
    },
    width: {
      type: Number,
      default: 900
    },
    activeIndex: {
      type: Number,
      default: 1
    },
    // 当前状态，可选  wait|process|finish|success|error
    status: {
      type: String,
      default: 'process'
    },
    successStatus: {
      type: String,
      default: 'success'
    }
  },
  data() {
    return {
      waitStatus: 'wait'
    }
  },
  computed: {
    style() {
      return {
        width: this.width + 'px'
      }
    }
  },
  methods: {
    /**
     * 获取步骤状态
     * @param {number} index 步骤index
     */
    stepStatus(index, reject = false) {
      if (index === this.activeIndex && reject && this.status === 'error') this.waitStatus = 'error'
      if (index < this.activeIndex) return this.successStatus
      else if (index > this.activeIndex) return this.waitStatus
      else return this.status
    }
  }
}
</script>
